import { Component } from '@angular/core';
import { SurveyForm } from '../../../shared/portal/survey-form/survey-form';

@Component({
  imports: [SurveyForm],
  selector: 'app-pt-home',
  styleUrl: './pt-home.css',
  templateUrl: './pt-home.html',
})
export class PtHome {}
